import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

type AccessState = {
  permissions: Array<string>
  user: APISimpleUser
  loaded: boolean
}

const initialState: AccessState = {
  permissions: [],
  user: undefined,
  loaded: false
}

const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    updateFromEnv: (state: AccessState, action: PayloadAction<AccessState>) => {
      const { permissions = [], user } = action.payload
      state.permissions = permissions
      state.user = user
      state.loaded = true
    },

    setPermissions: (
      state: AccessState,
      action: PayloadAction<Array<string>>
    ) => {
      state.permissions = action.payload
    },

    togglePermission: (state: AccessState, action: PayloadAction<any>) => {
      const [val, key]: [boolean, string] = action.payload

      if (val) {
        state.permissions.push(key)
      } else {
        state.permissions = state.permissions.filter(perm => perm !== key)
      }
    }
  }
})

export const { updateFromEnv, setPermissions, togglePermission } =
  accessSlice.actions

export const selectAccess = (state: RootState) => state.access

export default accessSlice.reducer
